import { render, staticRenderFns } from "./GGanttRow.vue?vue&type=template&id=0b9ca843&scoped=true"
import script from "./GGanttRow.vue?vue&type=script&lang=js"
export * from "./GGanttRow.vue?vue&type=script&lang=js"
import style0 from "./GGanttRow.vue?vue&type=style&index=0&id=0b9ca843&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ca843",
  null
  
)

export default component.exports